export let badgeDescriptions = {
    visionScore: "Vision Score:",
    damageDealtToTurrets: "Turret Damage:",
    totalMinionsKilled: "Creep Score:",
    totalDamageDealtToChampions: "Damage dealt to champions:",
    totalDamageTaken: "Damage taken:",
    wardsKilled: "Wards destroyed:",
    goldEarned: "Gold earned:",
    firstBloods: "First Bloods in game:",
    totalHealsOnTeammates: "Team Healed:",
    totalDamageShieldedOnTeammates: "Team Shielded:",
    totalTimeCCDealt: "Crowd controlling enemy players:",
    dragonKills: "Dragon Control:",
    baronKills: "Baron Control",
}

export let playerRoles = {
    BOTTOM: "Bottom Carry",
    TOP: "Top Lane",
    MIDDLE: "Mid Lane",
    JUNGLE: "Jungle",
    UTILITY: "Support"
}

export let badgeNames = {
    visionScore: "Vision Score",
    damageDealtToTurrets: "Turret Damage",
    totalMinionsKilled: "Creep Score",
    totalDamageDealtToChampions: "Champ Damage",
    totalDamageTaken: "Damage Taken",
    wardsKilled: "Wards Destroyed",
    goldEarned: "Gold Earned",
    firstBloods: "First Bloods",
    totalHealsOnTeammates: "Team Healed",
    totalDamageShieldedOnTeammates: "Team Shielded",
    totalTimeCCDealt: "Crowd Control",
    dragonKills: "Dragon Control",
    baronKills: "Baron Control",
}